import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../css/pages/settings.css';

import useCookie from "../hooks/useCookie";

const Settings = () => {
    const navigate = useNavigate();
    const [,setCookie] = useCookie();
    const [t, i18n] = useTranslation('global');   

    const changeLanguage = (e) => {
        i18n.changeLanguage(e.target.value);  
        let lang = JSON.stringify(e.target.value);
        setCookie("ULA", lang, { maxAge: 86400 }); 
      };
    
    const handleGoBack = () => {
        navigate('/');
    };

    return (
        <div className='settings-wrap'>
            <div className="header-title"><h1>{t('settings')}</h1></div>
            <div className='main-wrapper'>
                <div className="language-panel">
                    <div className="input-line">
                        <label htmlFor="lastName">{t('language')}</label>
                        <select
                        className="language-select"
                        name="languages_select"
                        id="languagesSelect"
                        onChange={changeLanguage}
                        value={i18n.language}
                        >
                        <option value="en">English</option>
                        <option value="sk">Slovenský</option>
                        <option value="cz">Český</option>
                        </select>
                    </div>
                </div>
            </div>
            <button className="return-button" onClick={handleGoBack}>{t('return')}</button>
        </div>
    );
};

export default Settings;